import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { DownloadsPage } from '@/features/monitoring/downloads-page'

export const Route = createFileRoute('/_authenticated/monitoring/downloads')({
  component: () => (
    <RequirePermission anyOf={['monitoring.read', 'subscriptions.read']}>
      <DownloadsPage />
    </RequirePermission>
  ),
})
